import { Box, Button, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ConsultList from "../components/Consults/ConsultList";
import { useSessionContext } from "../contexts/SessionContext";
import { useNavigate, useParams } from "react-router-dom";
import MeHelpers from "../services/Authentification/MeHelpers";
import LoginPage from "./LoginPage";
import i18n from "../i18n";
import parse from "html-react-parser";
import LoadingFullScreen from "../components/LoadingFullScreen";
import { useEffect } from "react";

export default function DashboardPage() {
  const { t } = useTranslation();
  const { initialized, user, organization } = useSessionContext();
  const { organizationId } = useParams<string>();
  const navigate = useNavigate();

  // If user is logged in but organizationId is missing, redirect to the correct route
  useEffect(() => {
    if (user && !organizationId && organization?.organization?.id) {
      navigate(`/organizations/${organization.organization.id}`);
    }
  }, [user, organizationId, organization?.organization?.id, navigate]);

  const isPractitioner = MeHelpers.isPractitionerOrAdmin(user);
  const disableCreation = !organization?.organization || organization.organization.createConsultPage.disableCreation || !organization.organization.active;
  const text = organization?.organization.createConsultPage.disableText ? organization.organization.createConsultPage.disableText[i18n.language] : undefined;

  if (!initialized) return <LoadingFullScreen center={true} />;

  // Don't render dashboard content if organizationId is missing after user logged in
  if (user && !organizationId) {
    return <LoadingFullScreen center={true} />;
  }

  return (
    <Container sx={{ marginTop: 5 }}>
      {disableCreation && text && (
        <Box textAlign="center" mt={3} mb={5}>
          <Typography variant="body1" fontSize={18}>
            {parse(text)}
          </Typography>
        </Box>
      )}

      {user ? (
        <Box>
          <Typography variant="h2" mb={3}>
            {t("dashboard.consults")} - {organization?.organization?.name ?? organizationId ?? ""}
          </Typography>

          {!isPractitioner && organization?.organization?.active && (
            <Button
              variant="contained"
              onClick={() => {
                navigate(`/organizations/${organizationId}/new-consult`);
              }}
              disabled={disableCreation}
            >
              {t("consult.create")}
            </Button>
          )}

          {organization?.organization && !organization.organization.active && (
            <Typography mt={1} sx={{ color: "#01579b" }}>
              {!organization.organization.active && <>{t("app.org-inactive-msg")}</>}
            </Typography>
          )}

          <Box marginTop={2}>
            <ConsultList />
          </Box>
        </Box>
      ) : (
        <LoginPage />
      )}
    </Container>
  );
}
